const directive = {
    red:(el)=>{
        el.style.color="red"
    }
}



export default  (Vue)=>{
    Object.keys(directive).forEach(key => {
        Vue.directive(key,directive[key])
    });
}